
import VueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    VueDropzone,
  },
  props: {
    tipoDoc: {
      type: String,
      default: () => '',
    },
  },

  data() {
    const urlDropzoneDev = `${process.env.SDAGENDA_API_DEV}/files/docs`
    const urlDropzoneProd = `${process.env.SDAGENDA_API_PROD}/files/docs`
    const urlDropzone = this.$isDev ? urlDropzoneDev : urlDropzoneProd
    return {
      dropzoneOptions: {
        url: urlDropzone,
        headers: {
          'x-access-token': 'mongodb-direct',
        },
        method: 'post',
        paramName: 'arquivo',
        maxFilesize: 1, // 1 MB
        maxFiles: 1,
        addRemoveLinks: true,
        uploadMultiple: false,
        thumbnailWidth: 200,
        dictRemoveFile: 'Remover arquivo',
        dictFileTooManyFiles: 'Você não pode fazer upload de mais arquivos.',
        dictCancelUpload: 'Cancelar upload',
        dictInvalidFileType: 'Tipo de arquivo inválido',
        dictFileTooBig: 'Arquivo muito grande, Tamanho máximo permitido: 1 MB.',
        acceptedFiles: 'image/*,application/pdf',
      },
    }
  },
  methods: {
    handleSuccess(file, response) {
      this.$emit('upload-success', response)
    },
    handleError(file, errorMessage) {
      this.$toast.error('error: ' + errorMessage)
      console.error(errorMessage)
      console.error(file.name)
      this.$refs.refDropzone.removeAllFiles()
    },
  },
}
